import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import MaintenanceFlowModels from './components/MaintenanceFlowModels';

const MaintenanceFlowModelsBridge = react2angular(MaintenanceFlowModels, [
  'businessId'
]);

export default MaintenanceFlowModelsBridge;
